export default "__VITE_ASSET__1a0de463__"